import { useAdvertiserId } from 'src/app/views/hooks/useAdvertiserId';
import { useCurrentUser } from 'src/app/views/hooks/useCurrentUser';
import { useDataCleanup } from 'src/app/views/hooks/useDataCleanup';
import { useFlowType } from 'src/app/views/hooks/useFlowType';
import { useHirerAccountAndContractBalance } from 'src/app/views/hooks/useHirerAccountAndContractBalance';
import { useIdentity } from 'src/app/views/hooks/useIdentity';
import { useJobData } from 'src/app/views/hooks/useJobData';
import { useJobId } from 'src/app/views/hooks/useJobId';
import { useTealiumEditOrRefreshFlowType } from 'src/app/views/hooks/useTealiumEditOrRefreshFlowType';
import type { ContainerProps } from 'src/types/app';

const MultiLocationContainer = ({ children }: ContainerProps) => {
  useDataCleanup();
  useFlowType('edit');
  useTealiumEditOrRefreshFlowType('edit');
  useAdvertiserId();
  useJobId();
  useHirerAccountAndContractBalance();
  useCurrentUser();
  useIdentity();
  useJobData();

  return <>{children}</>;
};

export default MultiLocationContainer;
